import Navigation from "@/reusable_sections/Header";
import Legacy from "./sections/Legacy";
import Standards from "./sections/Standards";
import ServiceArea from "./sections/ServiceArea";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Navigation />
      <Legacy />
      <Standards />
      <ServiceArea />
      <Footer />
    </div>;
}